import { Box, Text } from '@factorialco/deprecated-design-system'
import moment, { Moment } from 'moment'

import i18n from 'modules/core/lib/i18n'

import ContractTooltip from 'modules/contracts/components/ContractDetails/ContractTooltip'

interface Props {
  trialPeriod: Moment
  canEdit: boolean
}

const TRIAL_ALERT_DAYS_THRESHOLD = 28

const Details = ({ trialPeriod, canEdit }: Props) => {
  const now = moment()
  const hasExpired = trialPeriod ? trialPeriod.isBefore(now) : null
  const hasTrialAlert =
    canEdit &&
    trialPeriod &&
    trialPeriod.isAfter(now) &&
    trialPeriod.diff(now, 'days') < TRIAL_ALERT_DAYS_THRESHOLD

  return (
    <Box alignItems="center" gap="s4" flexDirection="row">
      {hasExpired && (
        <Text size="200" weight="normal" color="grey800">
          {i18n.t('contract_versions.contract_information.trial_period_reached')}
        </Text>
      )}
      {!hasExpired && (
        <Text size="200" weight="normal" color="grey800">
          {trialPeriod.fromNow()}
        </Text>
      )}
      {hasTrialAlert && (
        <ContractTooltip
          information={i18n.t('contract_versions.contract_information.trial_period_tooltip')}
          icon="alert-circle-line"
          color="radicalRed1000"
        />
      )}
    </Box>
  )
}

export default Details
